export const saveApp = (state) => {
  localStorage.setItem('RECO_APP', JSON.stringify(state));
};

export const loadApp = () => {
  return JSON.parse(localStorage.getItem('RECO_APP')) || {};
};
